import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { ThemeProvider } from "@/context/ThemeContext";
import { LeadModalProvider } from "@/context/LeadModalContext";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { FloatingCTA } from "@/components/layout/FloatingCTA";
import { LeadModal } from "@/components/lead/LeadModal";

import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import Contact from "@/pages/Contact";
import { PrivacyPolicy, Terms } from "@/pages/Legal";

function ScrollManager() {
	const { pathname, hash } = useLocation();
	useEffect(() => {
		if (hash) {
			const el = document.querySelector(hash);
			if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
		}
		window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
	}, [pathname, hash]);
	return null;
}

function App() {
	return (
		<ThemeProvider>
			<BrowserRouter>
				<LeadModalProvider>
					<div className="App min-h-screen bg-background text-foreground">
						<ScrollManager />
						<Navbar />
						<main>
							<Routes>
								<Route path="/" element={<Home />} />
								<Route path="/services/:id" element={<ServiceDetail />} />
								<Route path="/contact" element={<Contact />} />
								<Route path="/privacy-policy" element={<PrivacyPolicy />} />
								<Route path="/terms" element={<Terms />} />
							</Routes>
						</main>
						<Footer />
						<FloatingCTA />
						<LeadModal />
						<Toaster position="top-center" richColors />
					</div>
				</LeadModalProvider>
			</BrowserRouter>
		</ThemeProvider>
	);
}

export default App;
